import { Component, Vue, Prop } from 'vue-property-decorator';

@Component

export default class Input extends Vue {
  @Prop() public readonly placeholder!: string;
  @Prop() public readonly type!: string;
  @Prop() public readonly name!: string;
  @Prop() public readonly childComponent!: object;
  @Prop() public readonly accept!: string;

  private input: string | null | File = '';

  public onInputChange(event: InputEvent): void {
    const target = event.target as HTMLInputElement;
    if (this.type === 'file') {
        this.onInputFileChange(target);
    } else {
        this.onInputDefaultChange(target);
    }
  }

  private onInputFileChange(target: HTMLInputElement): void {
    const file = target && target.files && target.files[0];
    this.$emit('updateInput', file);
  }

  private onInputDefaultChange(target: HTMLInputElement): void {
    this.input = target && target.value;
    this.$emit('updateInput', this.input);
  }
}
